import { useTranslation } from 'react-i18next';

import { Typography, FONT_FAMILY, ColorSAP, Info } from '../../ontego-ui';

import Grid from '@mui/material/Grid2';
import Button from '../../ReusableComponents/Button/Button';
import DialogBox from '../../ReusableComponents/DialogBox/DialogBox';
import TertiaryButton from '../../ReusableComponents/TertiaryButton/TertiaryButton';
import Form from '../../ReusableComponents/Form/Form';
import { useState } from 'react';

const DeleteDialog = props => {
    const { title, dataName, confirmationText, open, onClose, onDelete } = props

    const [confirmationValue, setConfirmationValue] = useState("");

    const { t } = useTranslation();

    const handleClose = () => {
        setConfirmationValue("")
        onClose()
    }

    const handleChangeConfirmationValue = (event) => {
        setConfirmationValue(event.target.value)
    }

    return (
        <DialogBox
            dynamicTitle
            open={open}
            handleClose={handleClose}
            textTitle={t("manage.deleteObject", { object: t(title) })}
            content={
                <>
                    <div
                        style={{
                            width: 508,
                            paddingLeft: 24,
                            paddingRight: 24,
                            paddingBottom: 40,
                            boxSizing: 'border-box'
                        }}
                    >
                        <Grid container spacing={0} style={{ marginBottom: 24, marginTop: 24 }}>
                            <Grid item size={12}>
                                <div style={{ padding: "16px 24px 16px 24px", boxSizing: 'border-box', background: ColorSAP.secondary[30], borderRadius: 8, display: 'flex', alignItems: 'center', wordBreak: 'break-word' }}>
                                    <Info
                                        style={{
                                            width: 16,
                                            height: 16,
                                            color: ColorSAP.secondary[60],
                                            marginRight: 8
                                        }}
                                    />
                                    <Typography
                                        fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
                                        size={14}
                                        color={ColorSAP.neutral[100]}
                                    >
                                        {t("manage.deleteObject", { object: dataName })}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item size={12}>
                                <Typography
                                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
                                    size={14}
                                    color={ColorSAP.neutral[100]}
                                    style={{ marginTop: 8 }}
                                >
                                    {t("manage.deleteConfirmDesc")}
                                </Typography>
                            </Grid>
                            {confirmationText && 
                                <>
                                    <Grid item size={12}>
                                        <Typography
                                            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
                                            size={14}
                                            color={ColorSAP.neutral[100]}
                                            style={{ marginTop: 8 }}
                                        >
                                            {t("manage.deleteConfirmationText", { confirmationText: `"${confirmationText}"` })}
                                        </Typography>
                                    </Grid>
                                    <Grid item size={12} style={{ marginTop: 4, width: "100%" }}>
                                        <Form
                                            value={confirmationValue}
                                            onChange={handleChangeConfirmationValue}
                                        />
                                    </Grid>
                                </>
                            }
                        </Grid>
                        <Grid container style={{ marginTop: 30 }}>
                            <Grid item size={12}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <TertiaryButton
                                        theme="light"
                                        size="small"
                                        onClick={handleClose}
                                        noIcon={true}
                                    >
                                        {t(`manage.cancel`)}
                                    </TertiaryButton>

                                    <Button
                                        theme="danger"
                                        size="small"
                                        onClick={() => {
                                            if (!confirmationText || (confirmationText && confirmationText == confirmationValue)) { 
                                                onDelete()
                                                handleClose()
                                            }
                                        }}
                                        disabled={confirmationText && confirmationText != confirmationValue}
                                    >
                                        {t(`common.delete`)}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </>
            }
        />
    )
};

export default DeleteDialog;